import type { RouteId } from '../../app/router/routes'
import { PendingScreen } from './PendingScreen'
import { OPERATOR_SCREENS } from './operator'
import { PARENT_SCREENS } from './parent'
import { PUBLIC_SCREENS } from './public'
import { SCHOOL_SCREENS } from './school'
import { TEACHER_SCREENS } from './teacher'
import type { ConsoleScreenDef, ConsoleScreenMap } from './types'

/**
 * Routes that exist only in the redesign. Until a workstream registers the
 * real screen, they render `PendingScreen` rather than falling through to the
 * landing page.
 */
const NEW_ROUTES: readonly RouteId[] = [
  'platform-quotes',
  'platform-renewals',
  'platform-groups',
  'platform-people',
  'platform-support',
  'platform-games',
  'platform-devices',
  'platform-team',
  'school-try-games',
  'school-settings',
  'school-help',
  'teacher-play',
  'teacher-class',
  'teacher-children',
  'teacher-attendance',
  'teacher-reports',
  'teacher-messages',
  'teacher-help',
]

const pending: ConsoleScreenMap = {
  ...Object.fromEntries(NEW_ROUTES.map((id) => [id, { component: PendingScreen }])),
  'contact-sales': { component: PendingScreen, frame: 'bare' },
}

/** Tier maps win over the pending placeholders; later tiers never overlap. */
export const CONSOLE_SCREENS: ConsoleScreenMap = {
  ...pending,
  ...PUBLIC_SCREENS,
  ...OPERATOR_SCREENS,
  ...SCHOOL_SCREENS,
  ...TEACHER_SCREENS,
  ...PARENT_SCREENS,
}

export function consoleScreenFor(id: RouteId): ConsoleScreenDef | undefined {
  return CONSOLE_SCREENS[id]
}
